import React, { useCallback } from 'react';
import { TextField } from '@mui/material';
import { useSpeechInput } from '../../hooks/useSpeechInput';
import { DemoVoiceMicAdornment } from './DemoVoiceControls';

/**
 * TextField with a mic adornment that appends dictated speech.
 */
export default function DemoDictateTextField({
  value,
  onChange,
  InputProps,
  disabled,
  ...rest
}) {
  const handleTranscript = useCallback((text) => {
    const chunk = String(text || '').trim();
    if (!chunk) return;
    const prev = String(value || '');
    const next = `${prev}${prev && !prev.endsWith(' ') && !prev.endsWith('\n') ? ' ' : ''}${chunk}`;
    onChange?.({ target: { value: next } });
  }, [value, onChange]);

  const { isListening, startListening, stopListening, hasSupport } = useSpeechInput(handleTranscript);

  return (
    <TextField
      {...rest}
      value={value}
      onChange={onChange}
      disabled={disabled}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <>
            {InputProps?.endAdornment}
            <DemoVoiceMicAdornment
              hasSupport={hasSupport}
              isListening={isListening}
              disabled={disabled}
              onToggle={() => (isListening ? stopListening() : startListening())}
            />
          </>
        ),
      }}
    />
  );
}
